import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from './api.service';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  loading = null;
  user: any = null;
  total_seconds = 0;
  interval = null;
  clients: any = null;
  companies: any = null;

  constructor(private toastController: ToastController, private loadingController: LoadingController, private cookieService: CookieService, private apiService: ApiService) { }


  //Returns the current users information that is saved in cookies
  async GetUser() {
    return await JSON.parse(this.cookieService.get("user"));
    return {
      guid: '9bc386d5-8696-4a47-bcbb-f09b3e6c716e',
      display_name: 'Eric Greavette',
      img: './assets/images/1/1.jpg',
      settings: {
        files_system: {
          email_notification: 0,
          sort_by: 0,
          sort_by_asc: false,
          grid_view: false,
          hide_inactive: false,
        }
      }
    }
  }

  async UpdateUser(user) {
    this.user = user;
    this.cookieService.set('user', JSON.stringify(user));
    var return_user = JSON.parse(this.cookieService.get('user'));
    return this.cookieService.get('user');
  }

  async presentToastMessage(message, success) {
    let color = 'danger';
    if (success) color = 'success';
    const toast = await this.toastController.create({
      message: message,
      position: 'top',
      duration: 3000,
      color: color,
    })
    await toast.present()
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  createGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  isGUID(uuid) {
    const s = "" + uuid;
    const regularExpression = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    if (regularExpression === null) {
      return false;
    }
    return true;
  }

  //File helpers
  GetPathName(value) {
    return value.replace(/^.*(\\|\/|\:)/, '');
  }
  GetPathNameTwo(obj) {
    console.log(obj);
    if (obj.folder_title) return obj.folder_title;
    else return this.GetPathName(obj.path);
  }
  GetFileType(value) {
    var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    var m1 = (value).match(patt1)[1];
    return m1;
  }

  //Loading Controller Present
  async presentLoading(message, duration) {
    if (this.loading == null) {

      this.loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: message,
        duration: duration
      });
      await this.loading.present();

      // const { role, data } = await this.loading.onDidDismiss()
    }
  }

  async dismissLoading() {
    if (this.loading != null) {
      console.log("Not Null");
      this.loading.dismiss();
      this.loading = null;
    }
  }


  //Timer Logic
  async CheckTimer() {
    let cookie_timer = this.cookieService.get('timer');
    let timer_running = this.cookieService.get('timer_running');
    if (cookie_timer) {
      this.total_seconds = parseInt(cookie_timer);
      if (timer_running)
        this.StartTimer();
    }
  }


  convertMsToTime(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
    hours = hours % 24;

    return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}:${this.padTo2Digits(
      seconds,
    )}`;
  }
  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  async ResetTimer() {
    this.StopTimer();
    this.cookieService.set('timer', '', 0);
    this.total_seconds = 0;
  }

  async StartTimer() {
    this.cookieService.set('timer_running', '1', 0);
    if (!this.interval) {
      this.interval = setInterval(() => {
        //If we stop the cookie, it will stop all the timers as they hit the spot
        if (this.cookieService.get('timer_running')) {
          this.total_seconds += 1000;
          this.cookieService.set('timer', this.total_seconds.toString(), 0);
        } else {
          this.StopTimer()
        }

      }, 1000);
    }
  }

  async StopTimer() {
    clearInterval(this.interval);
    this.cookieService.set('timer_running', '', 0);
    this.interval = null;
  }

  RemoveFromArray(arr, guid) {
    var index = arr.findIndex(item => item.guid === guid);
    arr.splice(index, 1);
  }

  GetArrayIndex(arr, guid) {
    return arr.findIndex(item => item.guid === guid);
  }


  EnumToArrayTwo(enumme) {

    let map: { value: number; name: string }[] = [];
    for (var n in enumme) {
      if (typeof enumme[n] === 'number') {
        map.push({ value: <any>enumme[n], name: n });
      }
    }
    return map;
  }





  EnumToArray(enumme) {
    return Object.keys(enumme)
      .filter(value => isNaN(Number(value)) === false)
      .map(key => enumme[key]);
  }

  async GetFutureProjects(start_date, end_date) {
    let return_data = [];
    let projects_schedule: any = await this.apiService.get('projects_schedule');
    projects_schedule = projects_schedule.data;
    let schedule_data = projects_schedule;
    if (!schedule_data) return null;
    for (var i = 0; i < schedule_data.length; i++) {
      var item = schedule_data[i];
      var client_guid = item.client_guid;
      var company_guid = item.company_guid;

      if (client_guid) {
        var client = await this.GetClient(client_guid);
        if (!client) {
          continue;
        }
        this.CreateProjectEvent(return_data, item, start_date, end_date, client_guid, true);
      }
      if (company_guid) {
        var company = await this.GetCompany(company_guid);
        if (!company) {
          continue;
        }
        this.CreateProjectEvent(return_data, item, start_date, end_date, company_guid, false);
      }

    }
    return return_data;
  }

  async GetFutureTasks(start_date, end_date) {
    let return_data = []
    let project_data: any = await this.GetFutureProjects(start_date, end_date);
    project_data.forEach(project => {
      if (project.tasks) {
        project.tasks.forEach(task => {
          if (task) {
            if (task.relative_date) {
              if (task.relative_to_start) {
                task.due_date = dayjs(project.internal_start_date).startOf('day').add(task.due_date_relative, 'day').format('YYYY-MM-DD');
              }
              else {
                task.due_date = dayjs(project.internal_end_date).startOf('day').add(task.due_date_relative, 'day').format('YYYY-MM-DD');
              }
            }
            task.guid = this.createGUID();
            let cli_guid = project.client_guid;
            if (!project.client_guid) cli_guid = project.company_guid;

            task.uuid = project.project_scheduler_guid + cli_guid + task.due_date + task.title;
            task.is_fake = true;
            task.project = JSON.parse(JSON.stringify(project));

            if (dayjs(task.due_date).startOf('day') > dayjs(end_date).startOf('day')) {
              return;
            }


            if ((return_data.findIndex(item => item.uuid === task.uuid) == -1))
              return_data.push(task);
          }

          //Figure out when the task should be for the project
        });
      }
    });
    return return_data;
  }

  CreateProjectEvent(return_data, item, start_date, end_date, cli_guid, is_client) {
    let project_template = item.project_templates[0];
    let project_json_data = JSON.parse(project_template.json_str);
    let last_days_to_add = 0;
    let not_at_end = true;
    while (not_at_end) {

      var days_to_add = item.interval;
      var type_mod = 'day';
      if (item.pattern == 'daily') type_mod = 'day';
      else if (item.pattern == 'monthly') type_mod = 'month';
      else if (item.pattern == 'yearly') type_mod = 'year';


      days_to_add = item.interval + last_days_to_add;
      last_days_to_add = days_to_add;
      var next_date = dayjs().startOf('day').add(days_to_add, type_mod);


      const orgIntStartDate: string = project_json_data.internal_start_date;
      const orgIntEndDate: string = project_json_data.internal_end_date;
      const orgExtStartDate: string = project_json_data.external_start_date;
      const orgExtEndDate: string = project_json_data.external_end_date;

      let dateReference: dayjs.Dayjs = dayjs(orgIntEndDate);
      if (item.repeat_on_start) {
        dateReference = dayjs(orgIntStartDate);
      }

      var internal_start_date = "";
      var internal_end_date = "";
      var external_start_date = "";
      var external_end_date = "";
      var internal_start_date = dayjs(item.next_create_date).add(dayjs(orgIntStartDate).diff(dateReference, 'day'), 'day').add(days_to_add, type_mod).format('YYYY-MM-DD') + "T00:00:00";
      var internal_end_date = dayjs(item.next_create_date).add(dayjs(orgIntEndDate).diff(dateReference, 'day'), 'day').add(days_to_add, type_mod).format('YYYY-MM-DD') + "T00:00:00";
      var external_start_date = dayjs(item.next_create_date).add(dayjs(orgExtStartDate).diff(dateReference, 'day'), 'day').add(days_to_add, type_mod).format('YYYY-MM-DD') + "T00:00:00";
      var external_end_date = dayjs(item.next_create_date).add(dayjs(orgExtEndDate).diff(dateReference, 'day'), 'day').add(days_to_add, type_mod).format('YYYY-MM-DD') + "T00:00:00";

      if (dayjs(internal_start_date).startOf('day') > dayjs(end_date).startOf('day')) {
        not_at_end = false;
        continue;
      }
      let project_tasks = [];

      project_json_data.tasks.forEach(task => {
        if (task) {
          if (task.relative_date) {
            if (task.relative_to_start) {
              task.due_date = dayjs(internal_start_date).startOf('day').add(task.due_date_relative, 'day').format('YYYY-MM-DD');
            }
            else {
              task.due_date = dayjs(internal_end_date).startOf('day').add(task.due_date_relative, 'day').format('YYYY-MM-DD');
            }
          }
          task.guid = this.createGUID();
          let cli_guid = project_json_data.client_guid;
          if (!project_json_data.client_guid) cli_guid = project_json_data.company_guid;

          task.uuid = project_json_data.project_scheduler_guid + cli_guid + task.due_date + task.title;
          task.is_fake = true;

          // if (dayjs(task.due_date).startOf('day') > dayjs(end_date).startOf('day')) {
          //   return;
          // }


          if ((return_data.findIndex(item => item.uuid === task.uuid) == -1))
            project_tasks.push(task);
        }

        //Figure out when the task should be for the project
      });




      var project = {
        created_date: next_date.format('YYYY-MM-DD') + "T00:00:00",
        description: project_template.description,
        external_end_date: external_end_date,
        external_start_date: external_start_date,
        guid: item.guid + cli_guid + internal_start_date,
        internal_end_date: internal_end_date,
        internal_start_date: internal_start_date,
        progress: 0,
        status: 0,
        title: project_template.title,
        client_guid: is_client ? cli_guid : null,
        company_guid: is_client ? null : cli_guid,
        is_fake: true,
        project_scheduler_guid: item.guid,
        force_order: project_json_data.force_order,
        tasks: project_tasks,
        default_billing_rate: project_json_data.default_billing_rate

      }

      let add_project = true;
      if (dayjs(project.internal_start_date).isBefore(start_date) || dayjs(project.internal_start_date).isAfter(end_date)) add_project = false;

      if (return_data.findIndex(item => item.guid === project.guid) == -1 && add_project) return_data.push(JSON.parse(JSON.stringify(project)));
    }
  }

  async GetClient(guid) {
    if (this.clients == null) {
      this.clients = await this.apiService.get('clients');
      this.clients = this.clients.data;
    }
    var client = this.clients[this.clients.findIndex(item => item.guid === guid)];
    if (!client) {
      client = await this.apiService.get(`clients/${guid}`);
      client = client.data;
      if (!client) return null;
      else this.clients.push(client);
    }
    return this.clients[this.clients.findIndex(item => item.guid === guid)];
  }

  async GetCompany(guid) {
    if (this.companies == null) {
      this.companies = await this.apiService.get('companies');
      this.companies = this.companies.data;
    }
    var company = this.companies[this.companies.findIndex(item => item.guid === guid)];
    if (!company) {
      company = await this.apiService.get(`companies/${guid}`);
      company = company.data;
      if (!company) return null;
      else this.companies.push(company);
    }

    return this.companies[this.companies.findIndex(item => item.guid === guid)];
  }

  async GetProjects(start_date, end_date, url_mod) {
    let project_data = [];
    let data: any = await this.apiService.get(`projects?start_date=${start_date}&end_date=${end_date}${url_mod}`);
    if (data.success && data.data) {
      data.data.forEach(item => {
        if (item) {
          item.generated_id = item.project_scheduler_guid + item.client_guid + dayjs(item.internal_start_date).format('YYYY-MM-DD') + "T00:00:00";
          project_data.push(item);
        }
      });
    }
    else if (!data.success) {
      this.presentToastMessage(data.message, data.success);
      return;
    }

    let generated_projects = await this.GetFutureProjects(start_date, end_date);
    if (generated_projects) {
      generated_projects.forEach(item => {
        if (item) {
          var allowed = true;
          if (allowed) {
            project_data.forEach(proj => {
              if (item.guid == proj.generated_id) allowed = false
            })
          }
          if (allowed) {
            project_data.push(item);
          }
        }
      });
    }

    project_data.forEach(async project => {
      if (project.client_guid) {
        project.client = await this.GetClient(project.client_guid);
        project.linked_name = project.client.display_name;
      }
      else if (project.company_guid) {
        project.compay = await this.GetCompany(project.company_guid);
        project.linked_name = project.company.name;
      }
    });
    return project_data;
  }


  async CreateFromFakeProject(project) {

  }



  async waitForSeconds(seconds): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, seconds*1000));
  }

  private currentTooltip: any = null;

  ShowTooltip(event: Event, message: string): void {
    const el = event.target instanceof HTMLElement ? event.target : null;
    if (!el) return;
    this.HideTooltip();
    if (!message) return;
    el.setAttribute('data-bs-toggle', 'tooltip');
    el.setAttribute('data-bs-placement', 'top');
    el.setAttribute('title', message);
    el.setAttribute('data-bs-html', 'true');
    this.currentTooltip = new (window as any).bootstrap.Tooltip(el, { trigger: 'manual' });
    this.currentTooltip.show();
  }

  HideTooltip(): void {
    if (this.currentTooltip) {
      try { this.currentTooltip.dispose(); } catch {}
      this.currentTooltip = null;
    }
  }

}
